import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const DiscountReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Discount Report"
    description="Discount amount, percentage, net rate and approval status for every discounted booking."
    icon={<IconSystem.dollarSign size={18} />}
    phaseLabel="Coming in Phase 3"
    comingSoonHint="Tracks ₹ leakage per booking and which manager approved it."
  />
);
export default DiscountReportScreen;
